import { Box, Heading, Paragraph } from '@zillow/constellation-10';

import {
  wizardFlexContainerStyles,
  wizardFormSectionContainerStyles,
  wizardHeadingStyles,
  wizardParagraphStyles,
} from '../../../../styles/wizard';

import DateAvailableFormField from '../../../PostingPath/DateAvailableFormField';
import LeaseDurationFormFieldSelect from '../../../PostingPath/LeaseDurationFormField/LeaseDurationFormFieldSelect';
import LeaseTermsFormField from '../../../PostingPath/LeaseTermsFormField';
import MonthlyRentFeeAlert from '../../../PostingPath/MonthlyRentFeeAlert';
import MonthlyRentFormField from '../../../PostingPath/MonthlyRentFormField';
import PropertyDescriptionFormField from '../../../PostingPath/PropertyDescriptionFormField';
import SecurityDepositFormField from '../../../PostingPath/SecurityDepositFormField';
import SpecialOffers from '../../../PostingPath/SpecialOffers';
import PageWizard from '../../../Wizard/PageWizard';

import type { WizardBodyTemplateProps } from '../../../WizardStepController';

const RelistConfirmDetails = ({
  onGoToNextStep,
  onGoToPrevStep,
  onExitWizard,
  wizardTitle,
  progressStepper,
  totalSteps,
  currentStepIndex,
  ...rest
}: WizardBodyTemplateProps) => {
  return (
    <PageWizard
      {...rest}
      title=""
      wizardTitle={wizardTitle}
      progressStepper={progressStepper}
      totalSteps={totalSteps}
      currentStepIndex={currentStepIndex}
      onNextClick={onGoToNextStep || undefined}
      onBackClick={onGoToPrevStep || undefined}
      onExitTriggered={onExitWizard}
      hideBackButton={true}
    >
      <div data-testid="RelistConfirmDetails">
        <Box css={wizardFlexContainerStyles}>
          <Box css={wizardFormSectionContainerStyles.raw()}>
            <Heading level={2} textStyle="heading-sm" css={wizardHeadingStyles}>
              Are these details still accurate?
            </Heading>
            <Paragraph css={wizardParagraphStyles}>
              Review and update any information that has changed since you last listed this property.
            </Paragraph>

            <Box
              css={{
                display: 'grid',
                gridTemplateColumns: { base: 'repeat(12, 1fr)', lgDown: 'repeat(6, 1fr)' },
                columnGap: '400',
                marginBottom: '800',
              }}
            >
              <Box css={{ display: 'grid', gridColumnEnd: 'span 6', marginBottom: { base: '800', lg: 0 } }}>
                <MonthlyRentFormField isRelistingFieldset={true} />
              </Box>
              <Box css={{ display: 'grid', gridColumnEnd: 'span 6' }}>
                <SecurityDepositFormField showOneMonthsRentButton={false} />
              </Box>
              <MonthlyRentFeeAlert css={{ gridColumn: '1 / -1', marginTop: '400' }} />
            </Box>

            <Box
              css={{
                display: 'grid',
                gridTemplateColumns: { base: 'repeat(12, 1fr)', lgDown: 'repeat(6, 1fr)' },
                columnGap: '400',
                marginBottom: '800',
              }}
            >
              <Box css={{ display: 'grid', gridColumnEnd: 'span 6', marginBottom: { base: '800', lg: 0 } }}>
                <LeaseDurationFormFieldSelect />
              </Box>
              <Box css={{ display: 'grid', gridColumnEnd: 'span 6' }}>
                <DateAvailableFormField showNextMonthButton={false} />
              </Box>
            </Box>

            <Box css={{ marginBottom: '800' }}>
              <LeaseTermsFormField isRelistingFieldset={true} />
            </Box>

            <Box css={{ marginBottom: '800' }}>
              <PropertyDescriptionFormField isRelistingFieldset={true} />
            </Box>

            <Box css={{ marginBottom: '800' }}>
              <SpecialOffers isRelistingFieldset={true} />
            </Box>
          </Box>
        </Box>
      </div>
    </PageWizard>
  );
};

export default RelistConfirmDetails;
